import { styled, alpha, Typography } from '@mui/material';

export const ReferenceTag = styled(Typography)(({ theme }) => ({
  background: alpha(theme.palette.text.primary, 0.12),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  fontSize: 8,
  verticalAlign: 'middle',
  marginLeft: theme.spacing(1),
}));
